module.exports = __webpack_public_path__ + "static/media/4.198e07d9.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/lida/4.JPG
// module id = 539
// module chunks = 0